const membersSubscribedPackagesData = (state = null, action) => {
  if (action.type === "SET_MEMBERS_SUBSCRIBED_PACKAGES_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_MEMBERS_SUBSCRIBED_PACKAGES_DATA": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default membersSubscribedPackagesData;
